<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M10.0003 4L4 7.00015L10.0003 10.0003L16.0006 7.00015L10.0003 4Z" stroke="#4563FF" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M4 13L10.0003 16.0001L16.0006 13" stroke="#4563FF" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M4 10L10.0003 13.0001L16.0006 10" stroke="#4563FF" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
